// In an embed (linkBase set), tooltip links that jump to a section of the
// results page ("#about-the-data") need the page's URL, and every link opens
// in a new tab instead of inside the iframe
export default function tooltipHTML(html: string, linkBase?: string) {
  if (!linkBase) return html;
  return html
    .replace(/href="#/g, `href="${linkBase}#`)
    .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
}
